import React from "react";
import Button from '@mui/material/Paper';
import { ValidatePartnerAdminFuncInput } from "./ValidatePartnerAdminFuncInput";
const btnsArray = [{ operation: "Delete" }, { operation: "Cancel" }];

export default function OverviewButtons({
  partner,
  navigate,
  _partnerExistSoft,
  _createErrorMessage,
  _deletePartner,
}) {
  const onClick = (operation) => {
    if (operation === "Cancel") {
      let navigationNextUrl = `/PartnerOverview`;
      navigate(navigationNextUrl);
      return;
    }

    let validationPartnerResult = ValidatePartnerAdminFuncInput(
      partner,
      _createErrorMessage
    );

    if (!validationPartnerResult) {
      return;
    }

    _partnerExistSoft({ data: { partnerId: partner } }, ({ data: isExist }) => {
      if (!isExist) {
        _createErrorMessage("34");
        return;
      }
      _deletePartner({ data: { Id: partner } });
    });
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        flexWrap: "wrap",
      }}
      className="customButton"
    >
      {btnsArray.map(({ operation, noValidation, navPath }, i) => (
        <div style={{ width: "48%", marginBottom: 15 }}>
          <Button
            className="btn btn-primary w-100"
            key={operation}
            onClick={() => onClick(operation, noValidation, navPath)}
          >
            {operation}
          </Button>
        </div>
      ))}
    </div>
  );
}
